

export function formatSmallNumber(value) {
  if (Math.abs(value) >= 0.01) {
    return value;
  }

  let sign = value < 0 ? '-' : '';

  let absValue = Math.abs(value);

  let valueStr = absValue.toFixed(20);

  let zeros = 0;

  for (let i = 2; i < valueStr.length; i++) {
    if (valueStr[i] === '0') {
      zeros++;
    } else if (valueStr[i] !== '.') {
      break;
    }
  }

  let significantDigits = valueStr.slice(zeros + 2, zeros + 4);

  let formattedNumber = `${sign}0.0(${zeros})${significantDigits}`;

  return formattedNumber;
}
